import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { ManagerResponse, Manager } from "../models/manager";
import { Observable } from "rxjs/Observable";
import { FileUpload } from "../models/file-upload";
import { NameId } from "../models/nameId";
import { saveAs as _importedSaveAs } from "file-saver";
import { HttpClient } from "@angular/common/http";
import { Response } from "@angular/http";

const URL = environment.apiBaseUrl;

@Injectable()
export class ManagerService {
  constructor(private http: HttpClient) {}

  public managers(
    startRow: number,
    endRow: number,
    searchText: string,
    sortCol: string,
    sortDesc: boolean,
    showInactive: boolean
  ): Observable<ManagerResponse> {
    const url =
      `${URL}managers?startRow=${startRow}&endRow=${endRow}&searchString=${searchText}` +
      `&sortColumn=${sortCol}&sortDescending=${sortDesc}&showInactive=${showInactive}`;

    return this.http.get(url).map((x: any) => {
      const res = new ManagerResponse();
      res.managers = x.data as Manager[];
      res.total = x.total;
      return res;
    });
  }

  public getManager(id: string): Observable<Manager> {
    return this.http.get<Manager>(`${URL}managers/${id}`);
  }

  public getAllSimple(): Observable<NameId[]> {
    return this.http.get<NameId[]>(`${URL}managers/allSimple`);
  }

  public updateManager(_manager: Manager) {
    return this.http.put(`${URL}managers`, _manager);
  }

  public addManager(_manager: Manager) {
    return this.http.post(`${URL}managers`, _manager);
  }

  public deactivate(id: number) {
    return this.http.post(`${URL}managers/deactivate/${id}`, null);
  }

  public activate(id: number) {
    return this.http.post(`${URL}managers/activate/${id}`, null);
  }

  public importFile(fileUpload: FileUpload) {
    return this.http.post(`${URL}managers/import`, fileUpload);
  }

  public downloadPayout(
    manager: Manager,
    quarterId: number,
    quarterName: string
  ) {
    return this.http
      .get(`${URL}managers/payout/${manager.id}/${quarterId}`, {
        responseType: "blob"
      })
      .subscribe((res: any) => {
        const filename = `${quarterName} ${manager.acronym} - ${
          manager.type
        }.xlsx`;
        _importedSaveAs(res, filename);
      });
  }

  public downloadPayoutTotals(
    quarterId: number,
    quarterName: string,
    finishedFunc: any
  ) {
    return this.http
      .get(`${URL}managers/payouttotals/${quarterId}`, { responseType: "blob" })
      .subscribe((res: any) => {
        const filename = `${quarterName} - Manager Payout Totals.xlsx`;
        _importedSaveAs(res, filename);
        if (finishedFunc) {
          finishedFunc();
        }
      });
  }
}
